import { getCoverDisplayUrl } from '../../utils/coverUrl';
import React from 'react';
import { Play } from 'lucide-react';

const getCoverUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api')) return `${window.location.origin}${url}`;
  return url;
};

const TrailerSection = ({ book, trailerUrl, trailerExternalUrl }) => {
  if (!trailerUrl && !trailerExternalUrl) return null;

  return (
    <div id="trailer-section" className="bg-gradient-to-b from-black/55 to-black/65 backdrop-blur-sm py-12" data-testid="trailer-section">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
          <Play className="h-6 w-6 mr-2 text-red-500" />
          Book Trailer
        </h2>
        <div className="relative rounded-xl overflow-hidden bg-black shadow-2xl">
          {trailerExternalUrl ? (() => {
            const ytMatch = trailerExternalUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([a-zA-Z0-9_-]{11})/);
            if (ytMatch) {
              return (
                <iframe
                  src={`https://www.youtube.com/embed/${ytMatch[1]}`}
                  title="Book Trailer"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full aspect-video"
                  style={{ border: 'none' }}
                  data-testid="trailer-youtube"
                />
              );
            }
            if (trailerExternalUrl.includes('facebook.com') || trailerExternalUrl.includes('fb.watch')) {
              return (
                <iframe
                  src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(trailerExternalUrl)}&show_text=false&width=740`}
                  width="100%"
                  className="aspect-video"
                  style={{ border: 'none', overflow: 'hidden' }}
                  scrolling="no"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  allowFullScreen
                  title="Book Trailer"
                  data-testid="trailer-facebook"
                />
              );
            }
            return (
              <a
                href={trailerExternalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-64 text-white hover:text-red-400 transition-colors"
              >
                <Play className="h-12 w-12 mr-3" />
                <span className="text-lg">Watch Trailer</span>
              </a>
            );
          })() : (
            <video
              controls
              playsInline
              className="w-full aspect-video"
              poster={getCoverDisplayUrl(book.cover_image_url)}
              preload="auto"
              data-testid="trailer-video"
            >
              <source src={trailerUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {!trailerExternalUrl && book.trailer_duration && (
            <div className="absolute bottom-4 right-4 bg-black/70 px-2 py-1 rounded text-white text-sm">
              {Math.floor(book.trailer_duration / 60)}:{String(Math.floor(book.trailer_duration % 60)).padStart(2, '0')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrailerSection;
